// @ts-nocheck — 디자인 원본 스크립트 포팅 (faq-acc.js)
import type { Scope } from './scope';

/** FAQ <details> 부드러운 열고 닫기 (하나만 열림) */
export function initFaqAccordion(root: ParentNode, _s: Scope) {
  const dur = 340,
    ease = 'cubic-bezier(.2,.7,.2,1)';
  const kf = (a, h, show) => {
    const cs = getComputedStyle(a);
    const full = { height: h + 'px', paddingTop: cs.paddingTop, paddingBottom: cs.paddingBottom, opacity: 1 },
      zero = { height: '0px', paddingTop: '0px', paddingBottom: '0px', opacity: 0 };
    return show ? [zero, full] : [full, zero];
  };
  const close = (d) => {
    const a = d.querySelector('.a');
    d.classList.remove('on');
    if (!a) {
      d.open = false;
      return;
    }
    d.dataset.busy = 1;
    a.style.overflow = 'hidden';
    const an = a.animate(kf(a, a.offsetHeight, false), { duration: dur, easing: ease });
    an.onfinish = () => {
      d.open = false;
      a.style.overflow = '';
      delete d.dataset.busy;
    };
  };
  const open = (d) => {
    d.open = true;
    d.classList.add('on');
    const a = d.querySelector('.a');
    if (!a) return;
    d.dataset.busy = 1;
    a.style.overflow = 'hidden';
    const an = a.animate(kf(a, a.offsetHeight, true), { duration: dur, easing: ease });
    an.onfinish = () => {
      a.style.overflow = '';
      delete d.dataset.busy;
    };
  };
  root.querySelectorAll('.faq,.faq2').forEach((g) => {
    const ds = [...g.querySelectorAll('details')];
    ds.forEach((d) => {
      const sm = d.querySelector('summary');
      if (sm)
        sm.addEventListener('click', (e) => {
          e.preventDefault();
          if (d.dataset.busy) return;
          if (d.open) close(d);
          else {
            ds.forEach((o) => {
              if (o !== d && o.open) close(o);
            });
            open(d);
          }
        });
    });
  });
}
